import { Box, Divider, Typography } from "@mui/material";
import React from "react";
import { IPageTitleBarProps } from "./PageTitleBar.types";
import { CSS_CONSTANTS } from "../../constants/cssConstants";

export const PageTitleBar: React.FC<IPageTitleBarProps> = (props) => {
  const { heading, leftHeading, rightHeading, sx } = props;
  const isNode = React.isValidElement(rightHeading);
  const isLeftNode = React.isValidElement(leftHeading);

  return (
    <Box sx={sx}>
      <Box display="flex" justifyContent={"space-between"} alignItems="center">
        {heading ? (
          <Typography  variant="body1" fontSize={CSS_CONSTANTS.MAIN_HEADING_3}  fontWeight={"600"}>
            {heading}
          </Typography>
        ) : isLeftNode ? (
          <Box sx={{ minWidth: 0, flex: 1, mr: 2 }}>{leftHeading}</Box>
        ) : leftHeading ? (
          <Typography variant="body1" fontWeight={"400"}>
            {leftHeading}
          </Typography>
        ) : (
          <Box></Box>
        )}
        {isNode && <Box sx={{ flexShrink: 0 }}>{rightHeading}</Box>}
        {!isNode && (
          <Typography variant="body1" fontWeight={"400"}>
            {rightHeading}
          </Typography>
        )}
      </Box>
      
        <Divider
          sx={{
            mt: 1,
            mb: {
              md: 0.8,
              lg: 2,
              xl: 2,
            },
          }}
        />
      
    </Box>
  );
};
